import { CreateSkLkrlResponse } from 'src/sdk-servicing';
import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib/store';
import { CreateSkLkrlModel } from './create-sk-lkrl.state';

/** StateDetailsActions */
const ACTION_SET = '[CreateSkLkrl] set';
const ACTION_UPDATE = '[CreateSkLkrl] update';
const ACTION_RESET = '[CreateSkLkrl] reset';
const ACTION_FAIL = '[CreateSkLkrl] fail';
const ACTION_CANCEL_REQUEST = '[CreateSkLkrl] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[CreateSkLkrl] set from api';
const ACTION_UPDATE_FROM_API = '[CreateSkLkrl] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setCreateSkLkrl = createAction(ACTION_SET, props<WithRequestId<CreateSkLkrlModel>>());

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateCreateSkLkrl = createAction(ACTION_UPDATE, props<WithRequestId<Partial<CreateSkLkrlModel>>>());

/**
 * Clear the whole state, return to the initial one
 */
export const resetCreateSkLkrl = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelCreateSkLkrlRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failCreateSkLkrl = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setCreateSkLkrlFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<CreateSkLkrlResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateCreateSkLkrlFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<CreateSkLkrlResponse>>()
);
